import { createAsyncThunk } from '@reduxjs/toolkit';
import { BundleCategory as BundleCategoryService } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchBundleCategory,
  FindBundleCategory,
  GetBundleCategory,
} from './interface';

export const findBundleCategory = createAsyncThunk(
  'bundleCategory/findBundleCategory',
  async (values: FindBundleCategory, { rejectWithValue }) => {
    try {
      const response = await BundleCategoryService.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createBundleCategory = createAsyncThunk(
  'bundleCategory/createBundleCategory',
  async (values: CreatePatchBundleCategory, { rejectWithValue }) => {
    try {
      const response = await BundleCategoryService.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchBundleCategory = createAsyncThunk(
  'bundleCategory/patchBundleCategory',
  async ({ id, ...values }: CreatePatchBundleCategory, { rejectWithValue }) => {
    try {
      const response = await BundleCategoryService.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getBundleCategory = createAsyncThunk(
  'bundleCategory/getBundleCategory',
  async ({ id }: GetBundleCategory, { rejectWithValue }) => {
    try {
      const response = await BundleCategoryService.get(id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
